import React, { useContext, SyntheticEvent, FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

// MUI
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Toolbar from "@mui/material/Toolbar";

// MUI Icons
import BadgeIcon from '@mui/icons-material/Badge';

// Custom Components
import useFormController from "@/components/useFormController";
import DynamicDialog from "@/ui/Dialog/DynamicDialog";
import DialogHeader from "@/ui/Dialog/DialogHeader";
import DialogToolbarHeading from "@/ui/Dialog/DialogToolbarHeading";
import DialogToolbarButtonClose from "@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import DialogBody from "@/ui/Dialog/DialogBody";
import DialogActionButtonClose from "@/ui/Dialog/ActionButtons/DialogActionButtonClose";
import DialogContext from "@/ui/DialogContext/DialogContext";
import { GridContainer, GridItem } from "@/ui/Grid";
import FormContent from "@/components/FormContent";
import FormAvatar from "@/ui/Form/FormAvatar";

// Types
import { ClosingDetails, FormControllerProps } from "@/@types/components/formController";
import { IDialogProps } from "@/@types/ui/DialogContext";

const UserVodicDialog: FunctionComponent<IDialogProps> = (props) => {
  const dialogContext = useContext(DialogContext);
  const { t } = useTranslation();

  const { onClose } = props;

  const {
    record,
    fields,
    subModels
  } = useFormController(props as FormControllerProps);


  const handleClose = (evt: SyntheticEvent) => {
    close({ dataChanged: false, action: "cancel" });
  };

  const close = (result: ClosingDetails) => {
    onClose(result);
    dialogContext.hideDialog();
  };

  const cmode = "view";
 
  return (
    <DynamicDialog open maxWidth="md" onClose={handleClose}>
      <DialogHeader>
        <Toolbar variant="dense" disableGutters>
          <FormAvatar ariaLabel="avatar" icon={<BadgeIcon />} />
          <DialogToolbarHeading>{t("titles.planinarski_vodic")}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box m={2}>
          <GridContainer>
            <GridItem size={{xs: 12, sm: 6}}>
              <GridContainer>
                <FormContent
                  title="titles.osobni_podaci"
                  fieldNames={["first_name", "last_name", "oib", "email", "mobitel"]}
                  record={record}
                  fields={fields}
                  mode={cmode}
                  columns={1}
                  subModels={subModels}
                />
              </GridContainer>
            </GridItem>
            <GridItem size={{xs: 12, sm: 6}}>
              <GridContainer>
                <FormContent
                  title="titles.hps_podaci"
                  fieldNames={["hps_plan_udruga_id", "hps_spv_id", "hps_has_licenca", "hps_licenca_do", "hps_broj_vodicke_znacke"]}
                  record={record}
                  fields={fields}
                  mode={cmode}
                  columns={1}
                  subModels={subModels}
                />
              </GridContainer>
            </GridItem>
          </GridContainer>
        </Box>
      </DialogBody>
      <DialogActions>
        <DialogActionButtonClose variant="contained" onClick={handleClose} />
      </DialogActions>
    </DynamicDialog>
  );
};

export default UserVodicDialog;
